import { debounce } from 'lodash';
import { useCallback, useState } from 'react';
import { fetchOrderSuggestions } from './thunk';

/**
 * Custom hook for OrderAutocomplete logic.
 * 
 * @param {Object} props - Components props needed for logic
 * @returns {Object} State and handler methods
 */
export const useThunk = ({ value, organisationId, setError }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(value || '');

    const debouncedFetch = useCallback(
        debounce((term, orgId) => {
            if (term.length >= 4 && orgId) {
                setLoading(true);
                fetchOrderSuggestions({ term, organisation_id: orgId })
                    .then((res) => {
                        setOptions(res.results || []);
                    })
                    .catch((err) => {
                        console.error('Error fetching order suggestions:', err);
                        const errorMessage = err?.response?.data?.error_message || 'Failed to fetch order suggestions.';
                        if (setError) setError(errorMessage);
                        setOptions([]);
                    })
                    .finally(() => setLoading(false));
            } else {
                setOptions([]);
            }
        }, 500),
        [setError]
    );

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        if (organisationId) {
            debouncedFetch(newInputValue, organisationId);
        }
    };

    return {
        options,
        loading,
        inputValue,
        setInputValue,
        handleInputChange,
    };
};
